var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('mm-header'),_c('router-view',{staticClass:"router-view"}),_c('mm-dialog',{ref:"versionDialog",attrs:{"type":"alert","head-text":"更新提示","body-text":_vm.versionInfo}}),_c('audio',{ref:"mmPlayer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }